module.exports = __webpack_public_path__ + "static/media/selfie_iluminado.4593cf7f.svg";